"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.payloadTypeBeet = exports.isPayloadTypeNumber = exports.isPayloadTypeMerkleProof = exports.isPayloadTypeSeeds = exports.isPayloadTypePubkey = void 0;
const beet = __importStar(require("@metaplex-foundation/beet"));
const beetSolana = __importStar(require("@metaplex-foundation/beet-solana"));
const SeedsVec_1 = require("./SeedsVec");
const LeafInfo_1 = require("./LeafInfo");
const isPayloadTypePubkey = (x) => x.__kind === 'Pubkey';
exports.isPayloadTypePubkey = isPayloadTypePubkey;
const isPayloadTypeSeeds = (x) => x.__kind === 'Seeds';
exports.isPayloadTypeSeeds = isPayloadTypeSeeds;
const isPayloadTypeMerkleProof = (x) => x.__kind === 'MerkleProof';
exports.isPayloadTypeMerkleProof = isPayloadTypeMerkleProof;
const isPayloadTypeNumber = (x) => x.__kind === 'Number';
exports.isPayloadTypeNumber = isPayloadTypeNumber;
exports.payloadTypeBeet = beet.dataEnum([
    [
        'Pubkey',
        new beet.BeetArgsStruct([['fields', beet.fixedSizeTuple([beetSolana.publicKey])]], 'PayloadTypeRecord["Pubkey"]'),
    ],
    [
        'Seeds',
        new beet.FixableBeetArgsStruct([['fields', beet.tuple([SeedsVec_1.seedsVecBeet])]], 'PayloadTypeRecord["Seeds"]'),
    ],
    [
        'MerkleProof',
        new beet.FixableBeetArgsStruct([['fields', beet.tuple([LeafInfo_1.leafInfoBeet])]], 'PayloadTypeRecord["MerkleProof"]'),
    ],
    [
        'Number',
        new beet.BeetArgsStruct([['fields', beet.fixedSizeTuple([beet.u64])]], 'PayloadTypeRecord["Number"]'),
    ],
]);
//# sourceMappingURL=PayloadType.js.map